import { useGuestStore } from 'stores/guestStore';

export const useGuest = () => {
  const guestId = useGuestStore(state => state.guestId);
  const setGuestId = useGuestStore(state => state.setGuestId);

  return { guestId, setGuestId };
};
